import {Spin, Tabs} from "antd";
import React from "react";
import {ListUserGroupsController} from "./controller";
import "./index.css";
import FilterUserGroups from "./filterUserGroups";
import {listUserGroupTabTypes} from "./model";
import {UserGuideLink} from "../../user-guide/user-guide-link";
import { isNullOrUndefinedOrEmpty } from "src/common/utils";

const {TabPane} = Tabs;

function getTabName(tabStartText, tabMidText, userGroupList) {
    var size = 0;
    if(!isNullOrUndefinedOrEmpty(userGroupList)) {
      if(tabStartText === listUserGroupTabTypes.MyList) {
        userGroupList = userGroupList?.filter((userGroup) => userGroup.isMember === true);
      }
      size = Object.keys(userGroupList).length
    }
       return tabStartText + tabMidText + " ("+ size +")"
}

function ListUserGroups({userGroupTypeUniqueName}) {
  const {
    titleName,
    tabName,
    loading,
    columnName,
    userGroupList,
    errorFetchingDetails,
    onTabChange,
    activeTab,
    isViewPermissionMember,
    isBusinessTeam
  } = ListUserGroupsController(userGroupTypeUniqueName);
  return (
    <div className="user-groups-container">
      {errorFetchingDetails ? (
        <div className="error-text">Error Fetching Details</div>
      ) : (
        <Spin spinning={loading}>
          <div className="user-groups-title">
            {titleName}
            <UserGuideLink
              linkText="Click here to access the Business Team User Guide"
              isVisible={isBusinessTeam}
            />
          </div>
          <div className="user-groups-tabs">
            <Tabs
              type="card"
              onChange={onTabChange}
              activeKey={activeTab}
            >
              <TabPane
                tab={getTabName(listUserGroupTabTypes.AllList, tabName, userGroupList)}
                key={listUserGroupTabTypes.AllList}
              >
                <FilterUserGroups
                  columnName={columnName}
                  userGroupList={userGroupList}
                  viewMyUserGroups={false}
                  isViewPermissionMember={isViewPermissionMember}
                  enableInlineSearch={true}
                />
              </TabPane>
              <TabPane
                tab={getTabName(listUserGroupTabTypes.MyList, tabName, userGroupList)}
                key={listUserGroupTabTypes.MyList}
              >
                <FilterUserGroups
                  columnName={columnName}
                  userGroupList={userGroupList}
                  viewMyUserGroups={true}
                  enableInlineSearch={true}
                />
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      )}
    </div>
  );
}

export default ListUserGroups;
